<mat-card>
  <mat-card-header class="justify-content-center underline">
    <mat-card-title
      >{{ achRecord.userModel.firstName }}
      {{ achRecord.userModel.lastName }}</mat-card-title
      >
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div class="flex-row">
        <div class="flex-1">
          <h3 class="mt-2 underline"><strong>Bank Info</strong></h3>
          <ul>
            <li>
              <strong>Bank Name:</strong> {{ achRecord.bankName }}
            </li>

            <li>
              <strong>Routing Number:</strong>
              {{ achRecord.routingNumber }}
            </li>

            <li>
              <strong>Account Number:</strong>
              {{ achRecord.accountNumber }}
            </li>
            @if (achRecord.setupComplete) {
              <li>
                <strong>Setup :</strong> Completed
              </li>
            }

            @if (!achRecord.setupComplete) {
              <li class="red">
                <strong>Setup :</strong> Incomplete
              </li>
            }
          </ul>
        </div>
        <div class="flex-1">
          <h3 class="mt-2 underline"><strong>Contact Info</strong></h3>
          <ul>
            <li>
              <strong>Email Address:</strong>
              {{ achRecord.userModel.emailAddress }}
            </li>

            <li>
              <strong>Phone Number:</strong>
              {{ achRecord.userModel.primaryPhoneNumber }}
            </li>

            <li>
              <strong>Address:</strong>
              {{ achRecord.userModel.address }}
            </li>

            <li>
              <strong>City: </strong>
              {{ achRecord.userModel.city }}
            </li>

            <li>
              <strong>State:</strong>
              {{ achRecord.userModel.state }}
            </li>

            <li>
              <strong>Zip Code:</strong>
              {{ achRecord.userModel.zipCode }}
            </li>
          </ul>
        </div>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button (click)="onCloseButton()" mat-button>CLOSE</button>
    </mat-card-actions>
  </mat-card>
